module.exports = __webpack_public_path__ + "static/home-image-4-db4ca3140b4b027e9279513b5930062c.jpg";